import type { FaireProductEntity } from "../../entity_types/product";

export const p_25nww7b6d7: FaireProductEntity = {
  token: "p_25nww7b6d7",
  type: "product",
  name: "Halloween Squishy Sugar Fidget Kids Toy- Assorted",
  brandToken: "b_vm4serfd3h",
  brandName: "Label & Decore",
  imageUrl:
    "https://cdn.faire.com/fastly/7821bc4eaf5504ce396059d079c3b72b53d999aee9085a8546a8ed00730e7b32.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cafe881fda466796ccc6b72fb3150491f4831243c16727b59c4a5bde144f322a.png",
    "https://cdn.faire.com/fastly/02e232217c38ee871b3954534833de78c8d87529b61f4fcea14ea68a3a929d80.png",
    "https://cdn.faire.com/fastly/7c126bbeb2c1c89a8c82af713402160cffaa8f770131b4bc412ce72dd37b43bd.png",
    "https://cdn.faire.com/fastly/c22f3a9d39e0e95cf84d6aaa16c0078710d340528e70d1d6c0ffd904ca3bca79.jpeg",
  ],
  priceDollars: 6.25,
  description:
    "Add a delightfully spooky and sensory burst of fun to your holiday celebrations! Our Halloween Squishy Sugar Stocking Stuffer Fidget Kids Toy.\n\n🎃 Assorted Spooky Characters: Ships in a fun variety of classic Halloween silhouettes, including glowing pumpkins, spooky ghosts, creepy bats, and classic holiday monsters.\n\n🍬 Addictive Sugar-Gel Resistance: Packed with a thick, heavy maltose gel core. It feels weighted, provides a deeper tactile squeeze, and features an amazing slow-rebound return that keeps kids engaged.\n\n🛠️ Heavy-Duty Tear-Resistant TPR: Handcrafted from premium, non-toxic, and skin-safe thermoplastic rubber engineered to withstand aggressive twisting, pinching, and crushing without breaking.\n\n🎒 The Perfect Silent Travel Companion: Lightweight, compact, and completely quiet. Effortlessly slip it into school backpacks, candy buckets, or jacket pockets for quick grounding anywhere.\n\n🎁 The Ultimate Trick-or-Treat Alternative: An exceptional, allergy-safe standout choice for Halloween party favors, classroom reward bins, festive goody bags, or autumn stocking stuffers.",
  tags: [],
  msrpDollars: 12.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:48:33.774Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
